import React from "react"
import { Toaster } from "react-hot-toast"
import { TOAST_BASE_STYLE } from "~utils/toast-notify"

/** 高于 PopupProvider(10001)，避免 toast 被弹窗遮挡 */
const TOAST_Z_INDEX = 10002

/** H5 全局轻提示容器，挂载一次即可 */
export function AppToaster() {
  return (
    <Toaster
      position="top-center"
      containerStyle={{
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: TOAST_Z_INDEX,
      }}
      toastOptions={{
        duration: 2000,
        style: {
          ...TOAST_BASE_STYLE,
          background: "rgba(0, 0, 0, 0.75)",
          color: "#fff",
        },
      }}
    />
  )
}
